import { render, staticRenderFns } from "./MultiOptionsAnimatedButton.vue?vue&type=template&id=a147de22&scoped=true&"
import script from "./MultiOptionsAnimatedButton.vue?vue&type=script&lang=js&"
export * from "./MultiOptionsAnimatedButton.vue?vue&type=script&lang=js&"
import style0 from "./MultiOptionsAnimatedButton.vue?vue&type=style&index=0&id=a147de22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a147de22",
  null
  
)

export default component.exports